<template>
  <div class="border">
    <div @click="redirect()">
      <div class="cocktail">
        <img style="height: 150px;" src="/api/static/icons/cocktail (20231105111207).png">
        <!-- <img style="height: 150px;" src="/cocktail (20231105111207).png"> -->
        <div>
          <div class="name">{{ cocktail.name }}
            <div class="alc" v-if="cocktail.alcohols">Alc</div>
          </div>
          <div>
            <div class="ingr" v-for="ingr in cocktail.ingredients">{{ ingr }}</div>
          </div>
        </div>
      </div>
      <div>
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    cocktail: {
      type: Object,
      required: true, // обязательно
    },
    isRedirect: {
      type: Boolean,
      default: true,
      // required: false,
    }
  },
  methods: {
    redirect() {
      if (this.isRedirect) {
        this.$router.push(`/bar/cocktail/${this.cocktail.id}`)
      }
    }
  }
}
</script>

<style scoped>
.border {
  margin-top: 15px;
  padding: 5px;
  border: 6px solid var(--bar-color-main);
  border-radius: 15px;
}
.cocktail {
  display: flex;
  /* color: black; */
}
.name {
  display: flex;
  color: black;
  font-size: 40px;
  padding: 25px;
  /* align-self: center; */
  /* align-content: center; */
  align-items: center;
}
.alc {
  margin-left: 25px;
  color: HotPink;
  font-size: 40px;
}
.ingr {
  color: black;
  font-size: 30px;
}
</style>
